export const host: string = "https://api.wtg.kitg.com.ua";
export const hostImage: string = "https://api.wtg.kitg.com.ua/images";
export const ws: string = "wss://wtg.kitg.com.ua/api/wss";

export const api = {
  withAPI: `${host}`,
  withImageAPI: `${hostImage}`,
  withWS: `${ws}`,
};
